/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditspartcashback2Inputs */

const en_creditspartcashback2 = /** @type {(inputs: Creditspartcashback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback`)
};

const de_creditspartcashback2 = /** @type {(inputs: Creditspartcashback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback`)
};

/**
* | output |
* | --- |
* | "Cashback" |
*
* @param {Creditspartcashback2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditspartcashback2 = /** @type {((inputs?: Creditspartcashback2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditspartcashback2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditspartcashback2(inputs)
	return de_creditspartcashback2(inputs)
});
export { creditspartcashback2 as "creditsPartCashback" }